module.exports = "/_next/static/images/FrameMobile-e80c5b0d723f309bc7ebe8e1acc91871.webp";